import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'
import { IRevision, ISkinTrack } from '../ISkinTrack'
import { Limb } from '../Limb'
import { getSkinTrack } from '../Store/Actions'

import style from './Detail.scss'
import Note from './Note'
import Revisions from './Revisions'
import SkinTrack from './SkinTrack'

const Detail = () => {
  const [revision, setRevision] = useState<IRevision | undefined>()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const {
    customerId,
    limb,
    revision: currentRevisionKey,
  } = useParams<{ customerId: string; limb: Limb; revision?: string }>()

  const skinTrack = useAppSelector(state =>
    Object.values(state.skin_tracks.list).find(
      (oneSkinTrack: ISkinTrack) =>
        oneSkinTrack.limb === limb && oneSkinTrack.customerUuid === customerId,
    ),
  )

  useEffect(() => {
    if (!skinTrack) {
      dispatch(getSkinTrack(customerId, limb))
    }
  }, [])

  useEffect(() => {
    if (!skinTrack) {
      return
    }

    if (currentRevisionKey) {
      const foundRevision = skinTrack.revisions.find(
        oneRevision => oneRevision.revision === currentRevisionKey,
      )
      if (foundRevision) {
        setRevision(foundRevision)
      }
      return
    }

    setRevision(skinTrack.revisions[0])
  }, [skinTrack, currentRevisionKey])

  if (!skinTrack || !revision) {
    const loadingGif = '/react/public/skintrack/loading.gif'
    return (
      <div className={style.skinTrackApp}>
        <Link
          to={`/customers/${customerId}/skin-track`}
          className={style.backLink}>
          👈 {t('To overview')}
        </Link>
        <div className={style.skinTrackTool}>
          <div
            style={{
              margin: '0 auto',
              width: '100px',
              height: '100px',
              display: 'block',
              textAlign: 'center',
            }}>
            <img src={loadingGif} width={'100px'} />
            <br />
            <p>{t('Loading...')}</p>
          </div>
        </div>
      </div>
    )
  }

  const legacySkinTrack = {
    ...skinTrack,
    ...revision,
  }

  return (
    <div className={style.skinTrackApp}>
      <Link
        to={`/customers/${customerId}/skin-track`}
        className={style.backLink}>
        👈 {t('To overview')}
      </Link>
      <div className={style.skinTrackTool}>
        <SkinTrack skinTrack={legacySkinTrack} />

        <div className={style.info}>
          <Note skinTrack={legacySkinTrack} />
          <Revisions skinTrack={skinTrack} currentRevision={revision} />
        </div>
      </div>
    </div>
  )
}

export default Detail
